import { Box, BoxProps, ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { convertHexToRGBA, isIE } from '@jfs/ui-new/src/utils/utils'
import { FC, useCallback, useState } from 'react'
import { AccordionList } from '../../comps/AccordionList'
import { Button } from '../../comps/Button'
import { Modal } from '../../comps/Modal'
import { ModalHeader } from '../../comps/ModalHeader'
import { CardlessEMI } from '../../data/models/CardlessEMI'
import { EMIType } from '../../data/models/EMI'
import { useStores } from '../../data/store'
import { formatAmount, isIFrame } from '../../utils'
import { EMI, EMI_CARDTYPE, windowConfig } from '../../utils/constants'
import { Dropdown } from './DropDown'
import { SelectTenureCardless } from './SelectTenureCardless'

const DCEMI: FC<{
  show: boolean
  onClose: () => void
  setDCBankId: (id: string) => void
  setShowCardModal: (value: boolean) => void
  setShowPaymentProcessModal: (value: boolean) => void
}> = ({ show, onClose, setShowCardModal, setDCBankId, setShowPaymentProcessModal }) => {
  const { dcEMIList, theme, addPaymentMethod, getDCEMIPlans, updateIsOfferApplied, uniqueWindowId } = useStores(
    (root) => ({
      dcEMIList: root.getDebitCardEMIList(),
      theme: root.config.merchantTheme,
      addPaymentMethod: root.transaction.addPaymentMethod,
      getDCEMIPlans: root.getDCEMIPlans,
      updateIsOfferApplied: root.transaction.updateIsOfferApplied,
      uniqueWindowId: root.config.uniqueWindowId,
    }),
  )

  const { REACT_APP_ENDPOINT = '', REACT_APP_URL = '' } = process.env
  const [showModal, setShowModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState('')

  const loadProcessingScreen = useCallback(() => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`
    if (!isIFrame()) {
      window.currentChild = window
    } else {
      window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
      window.currentChild?.focus()
    }
    setShowPaymentProcessModal(true)
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, setShowPaymentProcessModal, uniqueWindowId])

  const setSelection = (value: string) => {
    const item = dcEMIList.find((item: any) => item?.text === value)?.id || ''
    setSelectedItem(item ?? '')
    const isDirectTenurePlan =
      dcEMIList.find((item: any) => item?.text === value)?.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI || ''
    if (isDirectTenurePlan) {
      setShowModal(true)
    } else {
      setDCBankId(item)
      setShowCardModal(true)
    }
  }

  const getSelectedvalue = () => {
    const selectedBank = dcEMIList?.find((item: any) => item.id === selectedItem)
    return selectedBank?.text ?? ''
  }

  const getCardEMIPlan = () => {
    // const cardBin = postDataRef.current.pan.replace(/[^0-9]/g, '').slice(0, 6)
    return getDCEMIPlans(selectedItem)
  }

  const onEMIPlanSelected = (item: any) => {
    console.log('onEMIPlanSelected item', item, dcEMIList)
    const schemeSubType = dcEMIList.find((data: any) => data?.id === selectedItem)?.schemeSubType || ''
    const newEMI = {
      bank: item.bank,
      tenure: item.tenure,
      scheme: item.scheme,
      schemeType: item.schemeType,
      value: item.value,
      interestRate: item.interestRate,
      processingFee: item.processingFee,
      processingFeeTax: item.processingFeeTax,
      convenienceFee: item.convenienceFee,
      convenienceFeeTax: item.convenienceFeeTax,
      cashBack: item.cashBack,
      paymentType: 'EMI',
      schemeSubType: schemeSubType,
    } as EMIType
    console.log('newEMI', newEMI)
    updateIsOfferApplied(false)
    addPaymentMethod(newEMI)
    loadProcessingScreen()

    setShowModal(!showModal)
  }

  const onDismiss = () => {
    console.log('onDismiss called')
    setShowModal(false)
    onClose()
  }

  if (!show) {
    if (selectedItem) {
      setSelectedItem('')
    }
    return null
  }

  return (
    <>
      <Dropdown
        data={dcEMIList}
        type={EMI.DEBIT_CARD}
        label={'Select Issuer Bank'}
        placeHolder={'Select Issuer Bank'}
        showLabel={false}
        onChange={setSelection}
        value={getSelectedvalue()}
        isNewPG={true}
        isModalSizeFixed={true}
        newSheet={true}
        setSelectedItem={setSelectedItem}
        onClose={() => onClose()}
      />

      {showModal && (
        <CardEMIPlansModal
          theme={theme}
          emiPlanList={getCardEMIPlan()}
          onEMIPlanSelected={(item: any) => {
            onEMIPlanSelected(item)
          }}
          isCardLessEmi={
            dcEMIList.find((item: any) => item?.id === selectedItem)?.schemeSubType === EMI_CARDTYPE.CARDLESS_EMI
          }
          onDismiss={onDismiss}
        />
      )}
    </>
  )
}

const CardEMIPlansModal = ({
  theme,
  emiPlanList,
  onEMIPlanSelected,
  onDismiss,
  isCardLessEmi,
}: {
  theme: any
  emiPlanList: any
  onEMIPlanSelected: (emi: any) => void
  onDismiss: () => void
  isCardLessEmi: boolean
}) => {
  const style = styles(theme)
  console.log('CardEMIPlansModal', emiPlanList)
  const renderHeader = ({ item }: any) => {
    console.log('CardEMIPlansModal item', item)
    return (
      <>
        <Box {...style.listEMIItemHeading(item.isExpanded)}>
          <Text
            {...style.headerEMIText(
              item.isExpanded,
            )}>{`₹${item.header.emi} X ${item.header.tenure} | ${item.header.interestRate}% p.a`}</Text>
          <Text {...style.headerEMIText(item.isExpanded)}>{`Payable: ₹${Number(item.header.amount).toFixed(2)}`}</Text>
        </Box>
        <Box {...style.separatorStyle} />
      </>
    )
  }
  const renderData = ({ item }: any) => {
    console.log('renderData', item)
    console.log('renderData1', `₹${formatAmount(item.emiProcessingFee.feeAmount)}`)
    const schemeNote = item?.schemeNote?.split('$1')

    return (
      <>
        <Box {...style.listEMIData}>
          <Text {...style.costBreakUp}>Cost Breakup</Text>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>Gross Amount</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.grossAmount)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>{`Interest Payable(${item.interestRate}%)`}</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.interest)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>
              {item.processingFeePecent ? `Processing fee(${item.processingFeePecent}%)` : 'Processing fee'}
            </Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.emiProcessingFee.feeAmount)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>{`Processing fee GST(${item.processingFeeTaxPercent}%)`}</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.processingFeeTax)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>
              {item.convenienceFeePercent ? `Convenience fee(${item.convenienceFeePercent}%)` : 'Convenience fee'}
            </Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.emiConvenienceFee.feeAmount)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.emiBreakupTitle}>{`Convenience fee GST(${item.convenienceFeeTaxPercent}%)`}</Text>
            <Text {...style.emiBreakupValue}>{`₹${formatAmount(item.convenienceFeeTax)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Box {...style.separatorStyle} />
          <Spacer size={20} />
          <Box {...style.modalDataContainer}>
            <Text {...style.totalPayable}>Total Payable</Text>
            <Text {...style.totalPayableAmount}>{`₹${formatAmount(item.totalAmount)}`}</Text>
          </Box>
          <Spacer size={20} />
          <Text {...style.emiBreakupTitle}>
            {schemeNote[0]}
            <Text fontSize={12} color={theme.bodyTextColor}>{`₹${formatAmount(item.totalAmount)}`}</Text>
            {schemeNote[1]}
          </Text>
          <Spacer size={24} />
          <Button
            isFull={true}
            title="Select Plan"
            onPress={() => {
              console.log('Selected Plan', item)
              onEMIPlanSelected(item)
              onDismiss()
              // if (isOfferApplied) {
              //   if (isValidBankEMIId(item.emiBankId)) {

              //   } else {
              //     onEMIPlanSelected(item)
              //     onDismiss()
              //   }
              // } else {
              //   onEMIPlanSelected(item)
              //   onDismiss()
              // }
            }}
          />
        </Box>
        <Box {...style.separatorStyle} />
      </>
    )
  }

  const onEmiTenureSubmit = (item: any) => {
    onEMIPlanSelected(item)
    onDismiss()
  }

  console.log('emiPlanList', emiPlanList)
  return (
    <Modal
      type={'BottomTop'}
      headerType="White_Bg"
      show={true}
      onDismiss={onDismiss}
      theme={theme}
      containerTopPadding={isIE() ? 5 : undefined}>
      <>
        <ModalHeader title={CardlessEMI ? 'Select EMI Tenure' : 'EMI Plan'} onDismiss={onDismiss} theme={theme} />
        {!isCardLessEmi && (
          <AccordionList theme={theme} data={emiPlanList} renderHeader={renderHeader} renderData={renderData} />
        )}
        {isCardLessEmi && <SelectTenureCardless data={emiPlanList} onEmiTenureSubmit={onEmiTenureSubmit} />}
      </>
    </Modal>
  )
}

const styles = (theme: any) => ({
  listItemHeading: (isSelected: boolean) =>
    ({
      borderBottomWidth: isSelected ? 2 : 0,
      borderBottomColor: theme.brandColor as ColorOptions,
      paddingVertical: 20,
      paddingHorizontal: 16,
      flexDirection: 'row',
      justifyContent: 'space-between',
    } as BoxProps),
  headerText: (isSelected: boolean) =>
    ({
      fontSize: 14,
      color: isSelected ? (theme.brandColor as ColorOptions) : (theme?.bodyTextColor as ColorOptions),
      fontWeight: '500',
    } as TextProps),
  text: {
    fontSize: 12,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  listData: {
    padding: 16,
    backgroundColor: convertHexToRGBA(theme?.brandColor, 10) as ColorOptions,
    underlayColor: theme?.bodyBgColor,
  } as BoxProps,
  emiPlans: {
    fontSize: 14,
    color: theme.brandColor as ColorOptions,
    fontWeight: '700',
    textDecorationLine: 'underline',
  } as TextProps,
  listEMIItemHeading: (isSelected: boolean) =>
    ({
      borderBottomWidth: isSelected ? 2 : 0,
      backgroundColor: theme.bodyBgColor as ColorOptions,
      borderBottomColor: theme.brandColor as ColorOptions,
      paddingVertical: 20,
      paddingHorizontal: 16,
      flexDirection: 'row',
      justifyContent: 'space-between',
    } as BoxProps),
  headerEMIText: (isSelected: boolean) =>
    ({
      fontSize: 12,
      color: isSelected
        ? (theme.brandColor as ColorOptions)
        : (convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions),
      fontWeight: isSelected ? 'bold' : '700',
    } as TextProps),
  separatorStyle: {
    height: 1,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions,
  } as BoxProps,
  listEMIData: {
    padding: 24,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 5) as ColorOptions,
    underlayColor: theme?.bodyBgColor,
  } as BoxProps,
  costBreakUp: {
    fontSize: 14,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: 'bold',
  } as TextProps,
  modalDataContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  emiBreakupTitle: {
    fontSize: 12,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  emiBreakupValue: {
    fontSize: 12,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: 'bold',
  } as TextProps,
  totalPayable: {
    fontSize: 14,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  totalPayableAmount: {
    fontSize: 14,
    color: theme?.brandColor as ColorOptions,
    fontWeight: 'bold',
  } as TextProps,
})

export { DCEMI }
